import { render, staticRenderFns } from "./FileInputV2.vue?vue&type=template&id=3c4bdfac&scoped=true&"
import script from "./FileInputV2.vue?vue&type=script&lang=js&"
export * from "./FileInputV2.vue?vue&type=script&lang=js&"
import style0 from "./FileInputV2.vue?vue&type=style&index=0&id=3c4bdfac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4bdfac",
  null
  
)

export default component.exports